module.exports = __webpack_public_path__ + "img/mosquito.9bbf18de.png";